export const pageShellStyle = {
  maxWidth: 1440,
};

export const pageFrameStyle = {
  borderRadius: 26,
  padding: 0,
  overflow: 'hidden',
  boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
  border: '1px solid #E5E7EB',
  background: '#FFFFFF',
};

export const heroSectionStyle = {
  padding: '22px 28px',
  background: 'linear-gradient(135deg, #7E22CE 0%, #C026D3 100%)',
  color: '#FFFFFF',
};

export const heroTitleStyle = {
  fontSize: 28,
  fontWeight: 800,
  marginBottom: 8,
};

export const heroDescriptionStyle = {
  fontSize: 15,
  lineHeight: 1.5,
  maxWidth: 920,
  opacity: 0.95,
};

export const pageBodyStyle = {
  padding: 28,
  background: '#F8FAFC',
};

export const surfaceCardStyle = {
  borderRadius: 18,
  border: '1px solid #E5E7EB',
  background: '#FFFFFF',
  boxShadow: '0 20px 45px rgba(15, 23, 42, 0.08)',
};

export const softInfoCardStyle = {
  ...surfaceCardStyle,
  background: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)',
};

export const metricCardStyle = {
  ...surfaceCardStyle,
  padding: 18,
};

export const sectionTitleStyle = {
  fontSize: 22,
  fontWeight: 800,
  marginBottom: 14,
};
